$(() => {
  $("form.edit_password_reset a.toggle-form").click(function(e){
    $("div.reset-password, div.link-account").slideToggle("slow");
    console.log("toggle!");
    e.preventDefault();
  });
});